import api from '@/api/classroom.api';
import store from '@/store';
import axios from 'axios';
// import { chatApiURL } from '../../../api/classroom.api.helper';

const classroomChatApi = process.env.VUE_APP_ENDPOINT_URL;
const nexusChatApi = process.env.VUE_APP_NEXUS_CHAT_URL;
const whichChatApi = () => {
  const isNexusUser =
    store &&
    store.state &&
    store.state.settings &&
    store.state.settings.isNexusUser;
  const chatapi = isNexusUser ? nexusChatApi : classroomChatApi;
  return chatapi;
};

const getClassroomDetailsByCode = (context, param) =>
  new Promise((resolve, reject) => {
    api
      .getClassroomDetailsByCode(param)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getClassroomById = (context, id) =>
  new Promise((resolve, reject) => {
    api
      .getClassroomById(id)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const joinClassroomByCode = (context, data) =>
  new Promise((resolve, reject) => {
    api
      .joinClassroomByCode(data.param, data.body)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updateUserExpressions = (context, data) =>
  new Promise((resolve, reject) => {
    api
      .updateUserExpressions(data.param, data.body)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getStudentProfile = (context, data) =>
  new Promise((resolve, reject) => {
    api
      .getStudentProfile(data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getClassroomsByStudent = context =>
  new Promise((resolve, reject) => {
    const params = {
      studentId: store.state.users.loggedInUserProfile.user.id,
    };
    api
      .getClassroomsByStudent(params)
      .then((response) => {
        context.commit('SAVE_STUDENT_CLASSES', response);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getOpenAssignmentsByClassId = (context, body) =>
  new Promise((resolve, reject) => {
    api
      .getOpenAssignmentsByClassId(body)
      .then((response) => {
        context.commit('SAVE_OPEN_ASSIGNMENTS', response.result);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getOpenAssignments = context =>
  new Promise((resolve, reject) => {
    api
      .getOpenAssignments()
      .then((response) => {
        context.commit('SAVE_ALL_OPEN_ASSIGNMENTS', response.result);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getClosedAssignmentsByClassId = (context, body) =>
  new Promise((resolve, reject) => {
    api
      .getClosedAssignmentsByClassId(body)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const leaveClassroomByStudent = (context, classId) =>
  new Promise((resolve, reject) => {
    const params = {
      classId,
    };
    api
      .leaveClassroomByStudent(params)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getStudent = context =>
  new Promise((resolve, reject) => {
    api
      .getStudent()
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getStudentSettingsByClass = (context, classId) =>
  new Promise((resolve, reject) => {
    api
      .getStudentSettingsByClass(classId)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updateStudentSettings = (context, body) =>
  new Promise((resolve, reject) => {
    api
      .updateStudentSettings(body)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const destroyStoredAssignment = (context, obj) =>
  new Promise((resolve, reject) => {
    context.commit('DESTROY_ALL_OPEN_ASSIGNMENTS');
    context.commit('DESTROY_OPEN_ASSIGNMENTS');
  });

const getUnseenMessagesForClass = (context, chatRoomId) =>
  new Promise((resolve, reject) => {
    const token = context.rootState.users.loggedInUserProfile.user.token;
    const chatapi = whichChatApi();
    const url = `${chatapi}/chat/conversations/${chatRoomId}/unseenMessages?apiKey=${token}`;
    axios
      .get(url, {
        headers: {
          'x-api-key': token,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getAssignmentByDktId = (context, dktAssignmentId) =>
  new Promise((resolve, reject) => {
    api
      .getAssignmentByDktId(dktAssignmentId)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const setClassCode = (context, classCode) => {
  context.commit('SET_CLASSCODE', classCode);
};

const setIsSaleNeeded = (context, value) => {
  context.commit('SET_NEED_SALES', value);
};

const setInvitationToken = (context, token) => {
  context.commit('SET_INVITATION_TOKEN', token);
};

export default {
  getClassroomDetailsByCode,
  getClassroomById,
  joinClassroomByCode,
  updateUserExpressions,
  getStudentProfile,
  getClassroomsByStudent,
  getOpenAssignmentsByClassId,
  getClosedAssignmentsByClassId,
  leaveClassroomByStudent,
  getStudent,
  getStudentSettingsByClass,
  updateStudentSettings,
  getOpenAssignments,
  destroyStoredAssignment,
  getUnseenMessagesForClass,
  getAssignmentByDktId,
  setClassCode,
  setIsSaleNeeded,
  setInvitationToken,
};
